import { useState } from 'react';
import { toast } from 'react-toastify';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ApiDatabase from '../../../../../server';

const ModalDeactivateAdminMember = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');
  const [isLoading, setIsLoading] = useState(false);

  const member = modalData || {};

  const handleConfirm = () => {
    setIsLoading(true);
    ApiDatabase.deactivateAdminTeamMember(
      { token, id_user: member._id },
      () => {
        setIsLoading(false);
        toast.success('Les accès ont été désactivés.');
        setModalDataReturn({ action: 'admin_member_deactivated', id_user: member._id });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur lors de la désactivation');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Désactiver les accès
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3 text-sm">
          <p className="text-gray-700">
            Êtes-vous sûr de vouloir désactiver les accès de <strong>{member.firstname} {member.lastname}</strong> ?
          </p>
          <p className="text-gray-500">
            Les données personnelles (prénom, nom, email) seront masquées et le membre n'apparaîtra plus dans la liste.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggle} size="LG" color="SECONDARY">
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          size="LG"
          color="PRIMARY"
          disabled={isLoading}
        >
          {isLoading ? 'Désactivation...' : 'Confirmer'}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalDeactivateAdminMember;
